import {
	slotSx,
	tagPlacementSx,
} from '@/components/blocks/PLPProductCard/styles/productSameDayTag';
import { SameDayTag } from '@/components/blocks/SameDayTag';
import { Box } from '@mui/material';

/** Same Day Delivery tag in the PLP product box (story 163100 AC1/AC2). */
export const ProductSameDayTag = () => (
	<Box sx={slotSx}>
		<SameDayTag sx={tagPlacementSx} />
	</Box>
);
